import {useState} from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import {Button, CircularProgress} from '@mui/material';
import {useForm} from 'react-hook-form';
import {FormContainer, TextFieldElement} from 'react-hook-form-mui';
import { useMutation } from "@tanstack/react-query";
import { API_URLS, axiosRequest } from "@lib/axios";

const ResetPasswordForm = ({ setPageMessage, setPageErrorMessage }) => {

  const [submitting, setSubmitting] = useState(false);

  const {
    handleSubmit,
    control,
  } = useForm({
    mode: 'onSubmit',
  });

  const sendForgotPasswordMutation = useMutation({
    mutationFn: async (data) => axiosRequest({
      method: 'POST',
      url: `${API_URLS.AUTH}/forgot-password`,
      data,
    }),
    onSuccess: async () => {
      setPageMessage('A reset password email has been sent to your email address. Please check your email and follow the instructions in the email.');
      setPageErrorMessage('');
    },
    onError: async (err) => {
      console.error('[ResetPassword] Error sending Forgot Password email:', err);
      setPageErrorMessage(err);
    },
    onSettled: () => {
      setSubmitting(false);
    },
  });

  const handleReset = ({ email }) => {
    setSubmitting(true);
    setPageMessage('');
    setPageErrorMessage('');

    sendForgotPasswordMutation.mutate({
      email
    });
  };

  return (
    <FormContainer onSuccess={handleSubmit(handleReset)} FormProps={{ className: 'mui' }}>
      <Grid container spacing={3}>
        {submitting && (
          <Grid xs={12} display="flex" justifyContent="center">
            <CircularProgress/>
          </Grid>
        )}
        {!submitting && (
          <>
            <Grid xs={12}>
              <TextFieldElement
                id="field-email"
                name="email"
                label={'Email'}
                placeholder="Enter your email here"
                control={control}
                autoComplete="email"
                required
                fullWidth
              />
            </Grid>
            <Grid xs={12}>
              <Button
                id="button-submit"
                variant="contained"
                size="small"
                type="submit"
                fullWidth
                sx={{ marginTop: '20px' }}
              >
                Send Link
              </Button>
            </Grid>
          </>
        )}
      </Grid>
    </FormContainer>
  );
};

export default ResetPasswordForm;
